import React from "react"

import {
  Wrapper,
  Heading,
  Logo,
  Image,
  Box,
  WrapperMobile,
  HeadingMobile,
  BoxMobile,
  LogoMobile,
} from "../../../TemplateBrand/Marque.style"
import { v4 as uuidv4 } from "uuid"
import { Media } from "gatsby-plugin-fresnel"
import { CommonWrapper } from "../../../../common/CommonWrapper"
import { Title as TitleBase } from "../../../../common/Title"
import styled from "styled-components"
import { ImageWithLinkOrNot } from "../../../../common/ImageWithLinkOrNot"
import { ColoredLine } from "../../../../common/ColorLine"

export interface Props {
  Marque: string
  DescriptionMarque: any
  LogoMarque: any
  LiensAssocies: any
  ImageMarque: any
  className?: string
}

export function BrandView({
  Marque,
  DescriptionMarque,
  LogoMarque,
  LiensAssocies,
  ImageMarque,
  className,
}: Props) {
  if(LogoMarque==null && ImageMarque==null){
    return(null)
  }

  return (
    <CommonWrapper>
      <Media lessThan="md">
        <WrapperMobile>
          <HeadingMobile className={className}>
            <BoxMobile>
              <TitleMobile label={Marque} className={""} />
              <ImageBrandComposition>
                <ImageMobile data={ImageMarque} objectFit="cover" />
                <LogoMobile data={LogoMarque} />
              </ImageBrandComposition>
              <DivHtmlMobile
                className={""}
                dangerouslySetInnerHTML={{
                  __html: DescriptionMarque?.data.childMarkdownRemark.html,
                }}
              />
              <ColoredLine color={"#E9E9E9"} height={"1px"} width={"100%"} />
            </BoxMobile>
          </HeadingMobile>
          <FlexColumn>
            {LiensAssocies?.map(item => (
              <Column>
                <Card data={item} key={uuidv4()} objectFit="cover" />
                <Subtitle>{item.Text}</Subtitle>
              </Column>
            ))}
          </FlexColumn>
          <ColoredLine color={"#E9E9E9"} height={"1px"} width={"100%"} />
        </WrapperMobile>
      </Media>
      <Media greaterThanOrEqual="md">
        <Wrapper>
          <Heading className={className}>
            <Flex>
              <Box>
                <Title label={Marque} className={""} />
                <DivHtml
                  className={""}
                  dangerouslySetInnerHTML={{
                    __html: DescriptionMarque?.data.childMarkdownRemark.html,
                  }}
                />
              </Box>
              <ImageBrandComposition>
                <Logo data={LogoMarque} />
                <Image data={ImageMarque} objectFit="cover" />
              </ImageBrandComposition>
            </Flex>
          </Heading>
          <ColoredLine color={"#E9E9E9"} height={"1px"} width={"100%"} />
          <Flex>
            {LiensAssocies?.map(item => (
              <Column>
                <Card data={item} key={uuidv4()} objectFit="cover" />
                <Subtitle>{item.Text}</Subtitle>
              </Column>
            ))}
          </Flex>
          <ColoredLine color={"#E9E9E9"} height={"1px"} width={"100%"} />
        </Wrapper>
      </Media>
    </CommonWrapper>
  )
}

const DivHtml = styled.div` 
  font: normal normal 300 18px/26px Poppins;
`
const DivHtmlMobile = styled.div`
  font-size: 15px;
  text-align: center;
`

const Flex = styled.div`
  width: 100%;
  margin: auto;
  display: flex;
  justify-content: space-between;
  gap: 60px;
  padding-top: 2em;
  margin: 0 auto;
`

const FlexColumn = styled.div`
  width: 100%;
  margin: auto;
  display: flex;
  flex-direction: column;
  gap: 60px;
  margin: 75px auto;
`

const Column = styled.div`
  min-height: 200px;
  min-width: 200px
  display: flex;
  flex-direction: column;
  gap: 25px;
  object-fit:contain;
  justify-content: space-between;
`

const Card = styled(ImageWithLinkOrNot)`
  height: 380px;
  width: 380px;
  margin: 0;
`

const Subtitle = styled.h1`
  text-align: center;
  font: normal normal bold 20px/22px Cormorant Garamond;
  color:  ${({ theme }) => theme.palette.primary.main};
  text-transform: uppercase;
`
const ImageBrandComposition = styled.div`
  position: relative;
`

const Title = styled(TitleBase)`
  width: 100%;
  text-align: left;
  font: normal normal 600 Cormorant Garamond;
  letter-spacing: -1px;
  color:  ${({ theme }) => theme.palette.primary.main};
  opacity: 1;
`

const TitleMobile = styled(TitleBase)`
  width: 100%;
  padding: 0;
  h1 {
    margin-top: 20px;
    font-size: 30px;
  }
`

const ImageMobile = styled(Image)`
  width: 100%;
  height: 272px;
`
